import MaintenanceWorkflowForwardingCheckinEntrySection from "../../../Sections/CheckinEntry";
import MaintenanceWorkflowForwardingDirectiveEntrySectionExecutionEntry from "../../../Sections/DirectiveEntry/Entries/ExecutionEntry";
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection from "../../../Sections/EstablishmentChoiceEntry";
import MaintenanceWorkflowForwardingFinancialReviewEntrySection from "../../../Sections/FinancialReviewEntry";
import MaintenanceWorkflowForwardingFiscalAssessmentEntrySection from "../../../Sections/FiscalAssessmentEntry";

const ExecutionEntryCompleted = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingFiscalAssessmentEntrySection />

      <MaintenanceWorkflowForwardingDirectiveEntrySectionExecutionEntry
        showCompleted
      />

      <MaintenanceWorkflowForwardingCheckinEntrySection />

      <MaintenanceWorkflowForwardingFinancialReviewEntrySection />

      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection
        manualEntryProps={{
          showProposalDiagnostic: true,
        }}
      />
    </>
  );
}

export default ExecutionEntryCompleted;
